import { cn } from '@orisini/ui/lib/utils'
import { STATUS_LABEL, type WorkspaceStatus } from '../lib/accounts'

const WARNA: Record<WorkspaceStatus, string> = {
  no_account: 'bg-muted text-muted-foreground',
  connected: 'bg-emerald-500/15 text-emerald-400',
  agent_offline: 'bg-amber-500/15 text-amber-400',
  needs_attention: 'bg-destructive/15 text-destructive',
  paused: 'bg-muted text-muted-foreground',
}

/** Status operasional project, sama di daftar Projects dan halaman project. */
export function StatusBadge({ status, className }: { status: WorkspaceStatus; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium', WARNA[status], className)}>
      <span className="size-1.5 rounded-full bg-current" aria-hidden />
      {STATUS_LABEL[status]}
    </span>
  )
}
